import { render, staticRenderFns } from "./PasswordResetDialog.vue?vue&type=template&id=fb22858a&scoped=true"
import script from "./PasswordResetDialog.vue?vue&type=script&lang=js"
export * from "./PasswordResetDialog.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetDialog.vue?vue&type=style&index=0&id=fb22858a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb22858a",
  null
  
)

export default component.exports